// Giriş ekranı, yüz tanıma ile giriş ve KVKK onayı için metinler.
const login = {
  title: 'Hoş geldiniz',
  subtitle: 'HabcareCRO portalına giriş yapın',
  email: 'E-posta',
  emailPlaceholder: 'ornek@habcarecro.com',
  password: 'Şifre',
  passwordPlaceholder: 'Şifreniz',
  showPassword: 'Şifreyi göster',
  hidePassword: 'Şifreyi gizle',
  capsLock: 'Caps Lock açık',
  submit: 'Giriş Yap',
  submitting: 'Giriş Yapılıyor...',
  or: 'veya',
  face: 'Yüz tanıma ile giriş',
  faceBusy: 'Cihazınız doğruluyor…',
  faceHint: 'Windows Hello, Face ID veya parmak izi',
  forgot: 'Şifremi Unuttum',
  language: 'Dil',
  copyright: '© HabcareCRO. Tüm hakları saklıdır.',
  errors: {
    invalid: 'Geçersiz e-posta veya şifre',
    inactive: 'Giriş Yetkiniz Kaldırılmıştır.',
    incomplete: 'Giriş işlemi tamamlanamadı',
    generic: 'Giriş işlemi sırasında bir hata oluştu',
    kvkkSave: 'KVKK onayı kaydedilemedi. Lütfen tekrar deneyin.',
    kvkkRejected: 'KVKK sözleşmesini kabul etmeden giriş yapamazsınız.',
  },
  setup: {
    title: 'Yüz tanıma kurulumu',
    body: 'Bu cihazda yüz tanıma henüz kurulmadı. Bir kez e-posta ve şifrenizle giriş yapın; ardından yüzünüzü tanıtacağız.',
    cancel: 'Vazgeç',
    tryAnyway: 'Bu cihazda zaten kurulu, yine de dene',
  },
  passkey: {
    cancelled: 'Yüz doğrulaması tamamlanmadı.',
    unknown: 'Bu cihazdaki yüz kaydı artık geçerli değil. Şifrenizle giriş yapıp yüzünüzü yeniden tanıtın.',
    inactive: 'Giriş Yetkiniz Kaldırılmıştır.',
    expired: 'İşlemin süresi doldu, lütfen tekrar deneyin.',
    unsupported: 'Bu cihaz yüz tanıma ile girişi desteklemiyor.',
    failed: 'Yüz tanıma ile giriş yapılamadı. Şifrenizle giriş yapabilirsiniz.',
  },
  enroll: {
    title: 'Yüzünüzü tanıtın',
    body: 'Cihazınız (Windows Hello, Face ID veya parmak izi) sizi bir kez doğrulayacak. Sonraki girişlerinizi bu cihazda şifre girmeden yapabilirsiniz.',
    privacy: "Yüz veriniz cihazınızdan çıkmaz; HabcareCRO'ya yalnızca cihazınızın imzaladığı bir doğrulama gelir.",
    start: 'Yüzümü tanıt',
    busy: 'Cihazınız bekleniyor…',
    skip: 'Şimdi değil',
    success: 'Yüz tanıma bu cihazda açıldı',
    exists: 'Yüz tanıma bu cihazda zaten açık',
    cancelled: 'Yüz tanıtma tamamlanmadı. Tekrar deneyebilir ya da şimdilik geçebilirsiniz.',
    freshLogin: 'Güvenlik için önce yeniden şifrenizle giriş yapın.',
    unsupported: 'Bu cihaz yüz tanıma ile girişi desteklemiyor.',
    failed: 'Yüz tanıma kurulamadı. Daha sonra tekrar deneyebilirsiniz.',
  },
  scan: {
    title: 'Yüz Tarama',
    subtitle: 'Kameraya bakın; giriş fotoğrafınız alınıyor.',
    camera: 'Kamera',
    cameraStarting: 'Açılıyor…',
    cameraOn: 'Etkin',
    cameraOff: 'Kullanılamıyor',
    photo: 'Giriş fotoğrafı',
    photoIn: '{{count}} sn',
    photoTaken: 'Alındı',
    processing: 'İşleniyor',
    starting: 'Kamera açılıyor...',
    skip: 'Şimdi Giriş Yap',
    continue: 'Devam Et',
    errors: {
      unsupported: 'Kamera bu tarayıcıda desteklenmiyor',
      denied: 'Kamera erişimi reddedildi',
      notFound: 'Kamera bulunamadı',
      failed: 'Kamera erişiminde hata oluştu',
      playback: 'Kamera erişimi sağlanamadı',
    },
  },
  reset: {
    title: 'Şifremi Unuttum',
    body: 'E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.',
    email: 'E-posta Adresi',
    send: 'Gönder',
    sending: 'Gönderiliyor...',
    cancel: 'İptal',
    success: 'Şifre sıfırlama bağlantısı e-posta adresinize gönderildi. Lütfen e-postanızı kontrol edin.',
    notFound: 'Bu e-posta adresi ile kayıtlı kullanıcı bulunamadı.',
    invalid: 'Geçersiz e-posta adresi.',
    failed: 'Şifre sıfırlama bağlantısı gönderilemedi. Lütfen tekrar deneyin.',
  },
  kvkk: {
    title: 'KVKK Aydınlatma Metni ve Açık Rıza Beyanı',
    subtitle: 'Devam etmek için lütfen okuyup onaylayın',
    protectionTitle: 'Kişisel Verilerin Korunması',
    protection: '6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz HCC HABCARE CRO tarafından aşağıda açıklanan kapsamda işlenebilecektir.',
    controllerTitle: 'Veri Sorumlusu',
    controller: 'Kişisel verileriniz, veri sorumlusu sıfatıyla HCC HABCARE CRO tarafından aşağıda açıklanan kapsamda işlenebilecektir.',
    dataTitle: 'İşlenen Kişisel Veriler',
    data: {
      identity: 'Kimlik bilgileri (ad, soyad, TC kimlik numarası)',
      contact: 'İletişim bilgileri (e-posta, telefon, adres)',
      employee: 'Çalışan bilgileri (departman, pozisyon, yetkilendirme)',
      logs: 'Giriş kayıtları ve sistem kullanım bilgileri',
      biometric: 'Biyometrik veriler (yüz tanıma görüntüleri)',
    },
    purposeTitle: 'Kişisel Verilerin İşlenme Amacı',
    purpose: {
      contract: 'İş sözleşmesinin kurulması ve ifası',
      hr: 'Çalışan yönetimi ve insan kaynakları süreçleri',
      security: 'Sistem güvenliği ve erişim kontrolü',
      legal: 'Yasal yükümlülüklerin yerine getirilmesi',
      safety: 'İş sağlığı ve güvenliği uygulamaları',
    },
    transferTitle: 'Kişisel Verilerin Aktarılması',
    transfer: 'Kişisel verileriniz, yukarıda belirtilen amaçlar doğrultusunda, yasal yükümlülüklerimizi yerine getirmek, iş sözleşmesinin ifası ve meşru menfaatlerimiz kapsamında gerekli olduğu ölçüde üçüncü kişilere aktarılabilecektir.',
    rightsTitle: 'Haklarınız',
    rightsIntro: "KVKK'nın 11. maddesi uyarınca, şirketimize başvurarak:",
    rights: {
      learn: 'Kişisel verilerinizin işlenip işlenmediğini öğrenme,',
      info: 'İşlenmişse buna ilişkin bilgi talep etme,',
      purpose: 'İşlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,',
      thirdParties: 'Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme,',
      correct: 'Eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,',
      erase: 'İlgili mevzuatta öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme,',
      notify: 'Aktarıldığı üçüncü kişilere yukarıdaki işlemlerin bildirilmesini isteme,',
      object: 'Münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,',
      damages: 'Kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme haklarına sahipsiniz.',
    },
    consent: 'KVKK Aydınlatma Metnini okudum, anladım ve kişisel verilerimin yukarıda belirtilen kapsamda işlenmesine açık rıza gösteriyorum.',
    accept: 'Kabul Ediyorum',
    reject: 'Kabul Etmiyorum',
  },
};

export default login;
